<div class="recent-confirmation-code-tile-container" (mouseenter)="onHover()" (mouseleave)="onLeave()">
  @if (confirmationCode) {
    <a
      [title]="passengerNames"
      [id]="id"
      class="{{
        this.isActive
          ? 'recent-confirmation-code-tile-link quantum-metric-encrypt'
          : 'recent-confirmation-code-tile-link quantum-metric-block'
      }}"
    >
      <div [class]="tileClasses">
        <div class="recent-confirmation-code-tile-icon-text-placement">
          @if (isHovered && !onlySingleConfirmationCode) {
            <auro-icon
              class="qm-recent-pnr-close"
              category="interface"
              name="x-lg"
              customColor
              [attr.customSize]="true"
              style="height: 16px; width: 16px; top: -2px; position: relative"
              (click)="removeConfirmationCode()"
            />
          } @else {
            <auro-icon
              category="interface"
              name="reservation-stroke"
              customColor
              [attr.customSize]="true"
              style="height: 16px; width: 16px; top: -2px; position: relative"
            />
          }
          <span
            [routerLink]="['reservation/', confirmationCode]"
            (click)="navigateToReservation(confirmationCode)"
            appSpaceOrEnterKeySelector
          >
            {{ confirmationCode }}
          </span>
        </div>
      </div>
    </a>
  }
</div>
